// src/ThemeProviderWrapper.jsx
import React, { useEffect } from "react";
import { ThemeProvider } from "./theming";

const ThemeProviderWrapper = ({ children, theme }) => {
  console.log("ThemeProviderWrapper - Received theme:", theme);

  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty("--color-accent", theme.accentColor || "#00838F");
    root.style.setProperty(
      "--color-background",
      theme.backgroundColor || "#F1F5F9"
    );
    // Also set --background so Tailwind's `bg-background` utility (used on body
    // via index.css) reflects the active theme — prevents a light-gray flash
    // when navigating between lazy-loaded pages.
    root.style.setProperty("--background", theme.backgroundColor || "#F1F5F9");
    // Paint <html> and <body> directly so the page never reveals the browser
    // default white during route transitions / Suspense swaps. The CSS-var
    // approach above governs Tailwind utilities; this governs the raw paint.
    root.style.backgroundColor = theme.backgroundColor || "#F1F5F9";
    if (document.body) {
      document.body.style.backgroundColor = theme.backgroundColor || "#F1F5F9";
    }
    root.style.setProperty(
      "--color-text-primary",
      theme.textColor || "#1F2937"
    );
    root.style.setProperty(
      "--color-text-secondary",
      theme.secondaryColor || "#4B5563"
    );
    root.style.setProperty("--color-charcoal", theme.charcoal || "#333333");
    root.style.setProperty(
      "--font-family-sans",
      theme.fontSans || "Inter, sans-serif"
    );
    root.style.setProperty(
      "--font-family-serif",
      theme.fontSerif || "Georgia, serif"
    );

    console.log("ThemeProviderWrapper - CSS variables applied:", theme);
  }, [theme]);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default ThemeProviderWrapper;
